import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectWithoutProperties from "/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var _excluded = ["isValid"],
  _excluded2 = ["isValid", "productType"],
  _excluded3 = ["isValid"],
  _excluded4 = ["isValid"],
  _excluded5 = ["isValid"],
  _excluded6 = ["isValid"];
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import axios from "axios";
import { request } from "@/js/http/http_request.js";
import { isAdminNotConsultant, getClientAppData } from "@/js/http/auth";
import { getErrorData, handleErrorData, ERROR_DATA, filterVAutocomplete } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { filterIntegerKey } from "@/js/events/keycodes.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
import UploaderV2 from "@/components/default/UploaderV2.vue";
import RegionSubImageUploadModal from "@/components/region/RegionSubImageUploadModal.vue";
var defaultFormAddSub = {
  name: "",
  priority: 0,
  isValid: false
};
var defaultFormAdd = {
  countryId: null,
  productType: null,
  name: "",
  description: "",
  regionSubs: [_objectSpread({}, defaultFormAddSub)],
  isValid: false
};
export default {
  name: "RegionFormModal",
  components: {
    Confirm: Confirm,
    ErrorModal: ErrorModal,
    UploaderV2: UploaderV2,
    RegionSubImageUploadModal: RegionSubImageUploadModal
  },
  props: {
    id: Number | null,
    initAddFormValues: Object | null,
    loggedUserData: Object
  },
  data: function data() {
    return {
      clientAppData: null,
      dialog: false,
      productTypes: [{
        id: "wines",
        text: "Wines"
      }, {
        id: "spirits",
        text: "Spirits"
      }],
      entity: null,
      gettingEntity: {
        isPending: false
      },
      gettingCountries: {
        isPending: false,
        cancellationToken: null,
        results: []
      },
      addingEntity: {
        form: _objectSpread({}, defaultFormAdd),
        isPending: false,
        cancellationToken: null,
        idCreated: null
      },
      editingTexts: {
        isConfiguring: false,
        form: {},
        isPending: false,
        cancellationToken: null
      },
      addingImage: {
        isConfiguring: false,
        url: "".concat(process.env.VUE_APP_API_URL, "/v1/regions/upload-image"),
        uploaderFiles: [],
        form: {
          regionId: null,
          sort: 1,
          isValid: false
        },
        isPending: false
      },
      deletingImage: {
        id: null,
        isPending: false,
        cancellationToken: null
      },
      resortingImage: {
        id: null,
        isConfiguring: false,
        form: {
          newSort: 1,
          isValid: false
        },
        isPending: false,
        cancellationToken: null
      },
      addingRegionSub: {
        isConfiguring: false,
        form: _objectSpread({}, defaultFormAddSub),
        isPending: false,
        cancellationToken: null
      },
      editingRegionSub: {
        id: null,
        isConfiguring: false,
        form: {},
        isPending: false,
        cancellationToken: null
      },
      addingRegionSubImage: {
        isConfiguring: false,
        regionSub: null
      },
      deletingRegionSubImage: {
        id: null,
        isPending: false,
        cancellationToken: null
      },
      formRules: formRules,
      filterIntegerKey: filterIntegerKey,
      filterVAutocomplete: filterVAutocomplete,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isAdding: function isAdding() {
      return !this.id > 0 && !this.addingEntity.idCreated > 0;
    },
    addingEntityIsValid: function addingEntityIsValid() {
      var _this$addingEntity$fo;
      return this.addingEntity.form.isValid && ((_this$addingEntity$fo = this.addingEntity.form.regionSubs) === null || _this$addingEntity$fo === void 0 ? void 0 : _this$addingEntity$fo.length) > 0;
    },
    addingImageMaxSort: function addingImageMaxSort() {
      var _this$entity$images$l, _this$entity$images;
      var existingMaxSort = (_this$entity$images$l = (_this$entity$images = this.entity.images) === null || _this$entity$images === void 0 ? void 0 : _this$entity$images.length) !== null && _this$entity$images$l !== void 0 ? _this$entity$images$l : 0;
      return existingMaxSort + 1;
    },
    addingImageCanBeSubmitted: function addingImageCanBeSubmitted() {
      var _this$addingImage$upl;
      return ((_this$addingImage$upl = this.addingImage.uploaderFiles) === null || _this$addingImage$upl === void 0 ? void 0 : _this$addingImage$upl.length) > 0 && this.addingImage.form.isValid;
    },
    addingImageFormWithouValidNormalized: function addingImageFormWithouValidNormalized() {
      var _this$entity;
      var _this$addingImage$for = this.addingImage.form,
        isValid = _this$addingImage$for.isValid,
        withoutValid = _objectWithoutProperties(_this$addingImage$for, _excluded);
      withoutValid.regionId = (_this$entity = this.entity) === null || _this$entity === void 0 ? void 0 : _this$entity.id;
      withoutValid.sort = +withoutValid.sort;
      return withoutValid;
    },
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.gettingEntity.isPending || this.addingEntity.isPending || this.editingTexts.isPending || this.addingImage.isPending || this.deletingImage.isPending || this.resortingImage.isPending || this.addingRegionSub.isPending || this.editingRegionSub.isPending || this.deletingRegionSubImage.isPending;
    },
    isAnySubFormInProgress: function isAnySubFormInProgress() {
      return this.editingTexts.isConfiguring || this.addingImage.isConfiguring || this.resortingImage.isConfiguring || this.addingRegionSub.isConfiguring || this.editingRegionSub.isConfiguring;
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.clientAppData = getClientAppData(_this2);
            _this2.getCountries();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    addingEntityStartAddRegionSub: function addingEntityStartAddRegionSub() {
      this.addingEntity.form.regionSubs.push(_objectSpread({}, defaultFormAddSub));
    },
    addingEntityRemoveRegionSub: function addingEntityRemoveRegionSub(index) {
      this.addingEntity.form.regionSubs.splice(index, 1);
    },
    confirmSaveAddingEntity: function confirmSaveAddingEntity() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this3.$refs.confirm.open("Confirm", "Are you sure to create this region ? Warning: A region cannot be deleted.", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(confirm) {
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!confirm) {
                          _context2.next = 3;
                          break;
                        }
                        _context2.next = 3;
                        return _this3.saveAddingEntity();
                      case 3:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    saveAddingEntity: function saveAddingEntity() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this4$addingEntity$c;
        var data, isValid, productType, withoutValid, _this, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this4.addingEntity.isPending = true;
              (_this4$addingEntity$c = _this4.addingEntity.cancellationToken) === null || _this4$addingEntity$c === void 0 || _this4$addingEntity$c.cancel();
              _this4.addingEntity.cancellationToken = axios.CancelToken.source();
              data = _objectSpread({}, _this4.addingEntity.form);
              data.isWineRegion = _this4.addingEntity.form.productType === "wines";
              data.isSpiritRegion = _this4.addingEntity.form.productType === "spirits";
              isValid = data.isValid, productType = data.productType, withoutValid = _objectWithoutProperties(data, _excluded2);
              _this = _this4;
              _context5.next = 10;
              return request("/v1/regions/", "post", withoutValid, true, "api", _this.addingEntity.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        _this.addingEntity.isPending = false;
                        _this.addingEntity.cancellationToken = null;
                        errorData = getErrorData(e, {}, "Unable to create the region.", true);
                        handleErrorData(_this, errorData);
                        throw e;
                      case 5:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 10:
              response = _context5.sent;
              _this4.addingEntity.idCreated = +response.data.value;
              _context5.next = 14;
              return _this4.getEntity();
            case 14:
              _this4.addingEntity.isPending = false;
              _this4.addingEntity.form = _objectSpread({}, defaultFormAdd);
              _this4.addingRegionSub.isConfiguring = false;
              _this4.addingRegionSub.form = _objectSpread({}, defaultFormAddSub);
              _this4.addingEntity.cancellationToken = null;
              _this4.$emit("entityUpdated");
              _this4.$toasted.show("Region created.", {
                type: "success"
              });
            case 21:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    startEditingTexts: function startEditingTexts() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this5.editingTexts.form = {
                name: _this5.entity.name,
                description: _this5.entity.description
              };
              _this5.editingTexts.isConfiguring = true;
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    cancelEditingTexts: function cancelEditingTexts() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this6.editingTexts.isConfiguring = false;
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    saveEditingTexts: function saveEditingTexts() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this7$editingTexts$c;
        var _this7$editingTexts$f, isValid, withoutValid, _this;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this7.editingTexts.isPending = true;
              (_this7$editingTexts$c = _this7.editingTexts.cancellationToken) === null || _this7$editingTexts$c === void 0 || _this7$editingTexts$c.cancel();
              _this7.editingTexts.cancellationToken = axios.CancelToken.source();
              _this7$editingTexts$f = _this7.editingTexts.form, isValid = _this7$editingTexts$f.isValid, withoutValid = _objectWithoutProperties(_this7$editingTexts$f, _excluded3);
              _this = _this7;
              _context9.next = 7;
              return request("/v1/regions/".concat(_this7.entity.id, "/texts"), "put", withoutValid, true, "api", _this.editingTexts.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        _this.editingTexts.isPending = false;
                        _this.editingTexts.cancellationToken = null;
                        errorData = getErrorData(e, {}, "Unable to edit the texts.", true);
                        handleErrorData(_this, errorData);
                        throw e;
                      case 5:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee8);
                }));
                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }());
            case 7:
              _this7.entity.name = _this7.editingTexts.form.name;
              _this7.entity.description = _this7.editingTexts.form.description;
              _this7.editingTexts.isPending = false;
              _this7.editingTexts.isConfiguring = false;
              _this7.editingTexts.form = {};
              _this7.editingTexts.cancellationToken = null;
              _this7.$emit("entityUpdated");
              _this7.$toasted.show("Texts updated.", {
                type: "success"
              });
            case 15:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    startAddingImage: function startAddingImage() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this8.addingImage.form.sort = _this8.addingImageMaxSort;
              _this8.addingImage.uploaderFiles = [];
              _this8.addingImage.isConfiguring = true;
            case 3:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    cancelAddingImage: function cancelAddingImage() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _this9.addingImage.isConfiguring = false;
            case 1:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    addingImageSyncFiles: function addingImageSyncFiles(uploaderFiles) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _this10.addingImage.uploaderFiles = _toConsumableArray(uploaderFiles);
            case 1:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    saveAddingImage: function saveAddingImage() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _this11.addingImage.isPending = true;
              _this11.$refs.uploaderAddingImage.uploadAll(true);
            case 2:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    addingImageUploadSuccess: function addingImageUploadSuccess(response) {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _this12.$emit("entityUpdated");
              _context14.next = 3;
              return _this12.getEntity();
            case 3:
              _this12.$nextTick(function () {
                _this12.addingImage.isPending = false;
                _this12.addingImage.isConfiguring = false;
              });
            case 4:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    addingImageUploadFailed: function addingImageUploadFailed() {
      this.addingImage.isPending = false;
    },
    startResortingImage: function startResortingImage(image) {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _this13.resortingImage.form.newSort = image.sort;
              _this13.resortingImage.id = image.id;
              _this13.resortingImage.isConfiguring = true;
            case 3:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }))();
    },
    cancelResortingImage: function cancelResortingImage() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _this14.resortingImage.id = null;
              _this14.resortingImage.isConfiguring = false;
            case 2:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }))();
    },
    saveResortingImage: function saveResortingImage() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var _this15$resortingImag;
        var _this15$resortingImag2, isValid, withoutValid, _this;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _this15.resortingImage.isPending = true;
              (_this15$resortingImag = _this15.resortingImage.cancellationToken) === null || _this15$resortingImag === void 0 || _this15$resortingImag.cancel();
              _this15.resortingImage.cancellationToken = axios.CancelToken.source();
              _this15$resortingImag2 = _this15.resortingImage.form, isValid = _this15$resortingImag2.isValid, withoutValid = _objectWithoutProperties(_this15$resortingImag2, _excluded4);
              _this = _this15;
              _context18.next = 7;
              return request("/v1/regions/images/" + _this.resortingImage.id + "/sort", "put", withoutValid, true, "api").catch(/*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee17$(_context17) {
                    while (1) switch (_context17.prev = _context17.next) {
                      case 0:
                        _this.resortingImage.isPending = false;
                        _this.resortingImage.cancellationToken = null;
                        errorData = getErrorData(e, {}, "Unable to resort the image.", true);
                        handleErrorData(_this, errorData);
                        throw e;
                      case 5:
                      case "end":
                        return _context17.stop();
                    }
                  }, _callee17);
                }));
                return function (_x4) {
                  return _ref4.apply(this, arguments);
                };
              }());
            case 7:
              _context18.next = 9;
              return _this15.getEntity();
            case 9:
              _this15.$emit("entityUpdated");
              _this15.$toasted.show("Image deleted.", {
                type: "success"
              });
              _this15.$nextTick(function () {
                _this15.resortingImage.isPending = false;
                _this15.resortingImage.cancellationToken = null;
                _this15.resortingImage.isConfiguring = false;
                _this15.resortingImage.id = null;
              });
            case 12:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }))();
    },
    confirmImageDelete: function confirmImageDelete(image) {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _this16.deletingImage.id = null;
              _this16.$refs.confirm.open("Delete image", "Are you sure to delete this image ? Warning: This action cannot be undone.", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee19(confirm) {
                  return _regeneratorRuntime().wrap(function _callee19$(_context19) {
                    while (1) switch (_context19.prev = _context19.next) {
                      case 0:
                        if (!confirm) {
                          _context19.next = 3;
                          break;
                        }
                        _context19.next = 3;
                        return _this16.imageDelete(image);
                      case 3:
                      case "end":
                        return _context19.stop();
                    }
                  }, _callee19);
                }));
                return function (_x5) {
                  return _ref5.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }))();
    },
    imageDelete: function imageDelete(image) {
      var _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
        var _this17$deletingImage;
        var _this;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _this17.deletingImage.isPending = true;
              (_this17$deletingImage = _this17.deletingImage.cancellationToken) === null || _this17$deletingImage === void 0 || _this17$deletingImage.cancel();
              _this17.deletingImage.cancellationToken = axios.CancelToken.source();
              _this17.deletingImage.id = image.id;
              _this = _this17;
              _context22.next = 7;
              return request("/v1/regions/images/" + image.id, "delete", null, true, "api").catch(/*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee21(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee21$(_context21) {
                    while (1) switch (_context21.prev = _context21.next) {
                      case 0:
                        _this.deletingImage.isPending = false;
                        _this.deletingImage.cancellationToken = null;
                        _this.deletingImage.id = null;
                        errorData = getErrorData(e, {}, "Unable to delete the image.", true);
                        handleErrorData(_this, errorData);
                        throw e;
                      case 6:
                      case "end":
                        return _context21.stop();
                    }
                  }, _callee21);
                }));
                return function (_x6) {
                  return _ref6.apply(this, arguments);
                };
              }());
            case 7:
              _context22.next = 9;
              return _this17.getEntity();
            case 9:
              _this17.$emit("entityUpdated");
              _this17.$toasted.show("Image deleted.", {
                type: "success"
              });
              _this17.$nextTick(function () {
                _this17.deletingImage.isPending = false;
                _this17.deletingImage.cancellationToken = null;
                _this17.deletingImage.id = null;
              });
            case 12:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      }))();
    },
    startAddingRegionSub: function startAddingRegionSub() {
      var _this18 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _this18.addingRegionSub.form = _objectSpread({}, defaultFormAddSub);
              _this18.addingRegionSub.isConfiguring = true;
            case 2:
            case "end":
              return _context23.stop();
          }
        }, _callee23);
      }))();
    },
    cancelAddingRegionSub: function cancelAddingRegionSub() {
      var _this19 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              _this19.addingRegionSub.isConfiguring = false;
            case 1:
            case "end":
              return _context24.stop();
          }
        }, _callee24);
      }))();
    },
    confirmSaveAddingRegionSub: function confirmSaveAddingRegionSub() {
      var _this20 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              _this20.$refs.confirm.open("Confirm", "Are you sure to create this subregion ? Warning: A subregion cannot be deleted.", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee25(confirm) {
                  return _regeneratorRuntime().wrap(function _callee25$(_context25) {
                    while (1) switch (_context25.prev = _context25.next) {
                      case 0:
                        if (!confirm) {
                          _context25.next = 3;
                          break;
                        }
                        _context25.next = 3;
                        return _this20.saveAddingRegionSub();
                      case 3:
                      case "end":
                        return _context25.stop();
                    }
                  }, _callee25);
                }));
                return function (_x7) {
                  return _ref7.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context26.stop();
          }
        }, _callee26);
      }))();
    },
    saveAddingRegionSub: function saveAddingRegionSub() {
      var _this21 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
        var _this21$addingRegionS;
        var _this21$addingRegionS2, isValid, withoutValid, _this, response;
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              _this21.addingRegionSub.isPending = true;
              (_this21$addingRegionS = _this21.addingRegionSub.cancellationToken) === null || _this21$addingRegionS === void 0 || _this21$addingRegionS.cancel();
              _this21.addingRegionSub.cancellationToken = axios.CancelToken.source();
              _this21$addingRegionS2 = _this21.addingRegionSub.form, isValid = _this21$addingRegionS2.isValid, withoutValid = _objectWithoutProperties(_this21$addingRegionS2, _excluded5);
              _this = _this21;
              _context28.next = 7;
              return request("/v1/regions/".concat(_this21.entity.id, "/region-subs"), "post", withoutValid, true, "api", _this.addingRegionSub.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee27(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee27$(_context27) {
                    while (1) switch (_context27.prev = _context27.next) {
                      case 0:
                        _this.addingRegionSub.isPending = false;
                        _this.addingRegionSub.cancellationToken = null;
                        errorData = getErrorData(e, {}, "Unable to add the subregion.", true);
                        handleErrorData(_this, errorData);
                        throw e;
                      case 5:
                      case "end":
                        return _context27.stop();
                    }
                  }, _callee27);
                }));
                return function (_x8) {
                  return _ref8.apply(this, arguments);
                };
              }());
            case 7:
              response = _context28.sent;
              _context28.next = 10;
              return _this21.getEntity();
            case 10:
              _this21.addingRegionSub.isPending = false;
              _this21.addingRegionSub.isConfiguring = false;
              _this21.addingRegionSub.form = _objectSpread({}, defaultFormAdd);
              _this21.addingRegionSub.cancellationToken = null;
              _this21.$emit("entityUpdated");
              _this21.$toasted.show("Subregion added.", {
                type: "success"
              });
            case 16:
            case "end":
              return _context28.stop();
          }
        }, _callee28);
      }))();
    },
    startEditingRegionSub: function startEditingRegionSub(regionSub) {
      var _this22 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
        return _regeneratorRuntime().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              _this22.editingRegionSub.form = {
                name: regionSub.name,
                priority: regionSub.priority
              };
              _this22.editingRegionSub.isConfiguring = true;
              _this22.editingRegionSub.id = regionSub.id;
            case 3:
            case "end":
              return _context29.stop();
          }
        }, _callee29);
      }))();
    },
    cancelEditingRegionSub: function cancelEditingRegionSub() {
      var _this23 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
        return _regeneratorRuntime().wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              _this23.editingRegionSub.isConfiguring = false;
              _this23.editingRegionSub.id = null;
            case 2:
            case "end":
              return _context30.stop();
          }
        }, _callee30);
      }))();
    },
    saveEditingRegionSub: function saveEditingRegionSub() {
      var _this24 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
        var _this24$editingRegion;
        var _this24$editingRegion2, isValid, withoutValid, _this;
        return _regeneratorRuntime().wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              _this24.editingRegionSub.isPending = true;
              (_this24$editingRegion = _this24.editingRegionSub.cancellationToken) === null || _this24$editingRegion === void 0 || _this24$editingRegion.cancel();
              _this24.editingRegionSub.cancellationToken = axios.CancelToken.source();
              _this24$editingRegion2 = _this24.editingRegionSub.form, isValid = _this24$editingRegion2.isValid, withoutValid = _objectWithoutProperties(_this24$editingRegion2, _excluded6);
              _this = _this24;
              _context32.next = 7;
              return request("/v1/regions/region-subs/".concat(_this24.editingRegionSub.id), "put", withoutValid, true, "api", _this.editingRegionSub.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee31(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee31$(_context31) {
                    while (1) switch (_context31.prev = _context31.next) {
                      case 0:
                        _this.editingRegionSub.isPending = false;
                        _this.editingRegionSub.cancellationToken = null;
                        errorData = getErrorData(e, {}, "Unable to edit the subregion.", true);
                        handleErrorData(_this, errorData);
                        throw e;
                      case 5:
                      case "end":
                        return _context31.stop();
                    }
                  }, _callee31);
                }));
                return function (_x9) {
                  return _ref9.apply(this, arguments);
                };
              }());
            case 7:
              _this24.editingRegionSub.isPending = false;
              _this24.editingRegionSub.isConfiguring = false;
              _this24.editingRegionSub.form = {};
              _this24.editingRegionSub.cancellationToken = null;
              _this24.editingRegionSub.id = null;
              _context32.next = 14;
              return _this24.getEntity();
            case 14:
              _this24.$emit("entityUpdated");
              _this24.$toasted.show("Subregion updated.", {
                type: "success"
              });
            case 16:
            case "end":
              return _context32.stop();
          }
        }, _callee32);
      }))();
    },
    startAddingRegionSubImage: function startAddingRegionSubImage(regionSub) {
      var _this25 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              _this25.addingRegionSubImage.isConfiguring = true;
              _this25.addingRegionSubImage.regionSub = _objectSpread({}, regionSub);
              _this25.$nextTick(function () {
                _this25.$refs.addingRegionSubImageModal.open();
              });
            case 3:
            case "end":
              return _context33.stop();
          }
        }, _callee33);
      }))();
    },
    addingRegionSubImageUploaded: function addingRegionSubImageUploaded() {
      var _this26 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
        return _regeneratorRuntime().wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              _context34.next = 2;
              return _this26.getEntity();
            case 2:
              _this26.addingRegionSubImage.isConfiguring = false;
              _this26.addingRegionSubImage.regionSub = null;
            case 4:
            case "end":
              return _context34.stop();
          }
        }, _callee34);
      }))();
    },
    addingRegionSubImageModalClosed: function addingRegionSubImageModalClosed() {
      var _this27 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
        return _regeneratorRuntime().wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              _this27.addingRegionSubImage.isConfiguring = false;
              _this27.addingRegionSubImage.regionSub = null;
            case 2:
            case "end":
              return _context35.stop();
          }
        }, _callee35);
      }))();
    },
    confirmRegionSubImageDelete: function confirmRegionSubImageDelete(image) {
      var _this28 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee37() {
        return _regeneratorRuntime().wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              _this28.deletingRegionSubImage.id = null;
              _this28.$refs.confirm.open("Delete image", "Are you sure to delete this image ? Warning: This action cannot be undone.", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee36(confirm) {
                  return _regeneratorRuntime().wrap(function _callee36$(_context36) {
                    while (1) switch (_context36.prev = _context36.next) {
                      case 0:
                        if (!confirm) {
                          _context36.next = 3;
                          break;
                        }
                        _context36.next = 3;
                        return _this28.regionSubImageDelete(image);
                      case 3:
                      case "end":
                        return _context36.stop();
                    }
                  }, _callee36);
                }));
                return function (_x10) {
                  return _ref10.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context37.stop();
          }
        }, _callee37);
      }))();
    },
    regionSubImageDelete: function regionSubImageDelete(image) {
      var _this29 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee39() {
        var _this29$regionSubImag;
        var _this;
        return _regeneratorRuntime().wrap(function _callee39$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              _this29.regionSubImageDelete.isPending = true;
              (_this29$regionSubImag = _this29.regionSubImageDelete.cancellationToken) === null || _this29$regionSubImag === void 0 || _this29$regionSubImag.cancel();
              _this29.regionSubImageDelete.cancellationToken = axios.CancelToken.source();
              _this29.regionSubImageDelete.id = image.id;
              _this = _this29;
              _context39.next = 7;
              return request("/v1/regions/region-subs/images/" + image.id, "delete", null, true, "api").catch(/*#__PURE__*/function () {
                var _ref11 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee38(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee38$(_context38) {
                    while (1) switch (_context38.prev = _context38.next) {
                      case 0:
                        _this.regionSubImageDelete.isPending = false;
                        _this.regionSubImageDelete.cancellationToken = null;
                        _this.regionSubImageDelete.id = null;
                        errorData = getErrorData(e, {}, "Unable to delete the image of the subregion.", true);
                        handleErrorData(_this, errorData);
                        throw e;
                      case 6:
                      case "end":
                        return _context38.stop();
                    }
                  }, _callee38);
                }));
                return function (_x11) {
                  return _ref11.apply(this, arguments);
                };
              }());
            case 7:
              _context39.next = 9;
              return _this29.getEntity();
            case 9:
              _this29.$emit("entityUpdated");
              _this29.$toasted.show("Image deleted.", {
                type: "success"
              });
              _this29.$nextTick(function () {
                _this29.regionSubImageDelete.isPending = false;
                _this29.regionSubImageDelete.cancellationToken = null;
                _this29.regionSubImageDelete.id = null;
              });
            case 12:
            case "end":
              return _context39.stop();
          }
        }, _callee39);
      }))();
    },
    getEntity: function getEntity() {
      var _this30 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee40() {
        var idToFetch, _this, response;
        return _regeneratorRuntime().wrap(function _callee40$(_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              idToFetch = _this30.id || _this30.addingEntity.idCreated;
              if (!(idToFetch > 0)) {
                _context40.next = 9;
                break;
              }
              _this30.gettingEntity.isPending = true;
              _this = _this30;
              _context40.next = 6;
              return request("/v1/regions/".concat(idToFetch), "get", null, true, "api").catch(function (e) {
                _this.gettingEntity.isPending = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to get region", true);
                handleErrorData(_this, errorData);
                throw e;
              });
            case 6:
              response = _context40.sent;
              _this30.entity = _objectSpread({}, response.data);
              _this30.gettingEntity.isPending = false;
            case 9:
            case "end":
              return _context40.stop();
          }
        }, _callee40);
      }))();
    },
    getCountries: function getCountries() {
      var _this31 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee41() {
        var _this31$gettingCountr;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee41$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              _this31.gettingCountries.isPending = true;
              (_this31$gettingCountr = _this31.gettingCountries.cancellationToken) === null || _this31$gettingCountr === void 0 || _this31$gettingCountr.cancel();
              _this31.gettingCountries.cancellationToken = axios.CancelToken.source();
              _this = _this31;
              _context41.next = 6;
              return request("/v1/countries/", "post", _this.clientAppData, true, "api", _this.gettingCountries.cancellationToken).catch(function (e) {
                _this.gettingCountries.isPending = false;
                _this.gettingCountries.cancellationToken = null;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to get list of countries", true);
                handleErrorData(_this, errorData);
                throw e;
              });
            case 6:
              response = _context41.sent;
              _this31.gettingCountries.results = _toConsumableArray(response.data.countries);
              _this31.gettingCountries.isPending = false;
              _this31.gettingCountries.cancellationToken = null;
            case 10:
            case "end":
              return _context41.stop();
          }
        }, _callee41);
      }))();
    },
    open: function open() {
      var _this32 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee42() {
        return _regeneratorRuntime().wrap(function _callee42$(_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              _this32.resetData();
              _this32.dialog = true;
              if (!(_this32.id > 0)) {
                _context42.next = 7;
                break;
              }
              _context42.next = 5;
              return _this32.getEntity();
            case 5:
              _context42.next = 8;
              break;
            case 7:
              if (_this32.initAddFormValues != null) {
                _this32.addingEntity.form = _objectSpread(_objectSpread({}, defaultFormAdd), _this32.initAddFormValues);
              }
            case 8:
              return _context42.abrupt("return", new Promise(function (resolve, reject) {
                _this32.resolve = resolve;
                _this32.reject = reject;
              }));
            case 9:
            case "end":
              return _context42.stop();
          }
        }, _callee42);
      }))();
    },
    close: function close() {
      if (!this.isAnyActionInProgress) {
        this.dialog = false;
        this.resetData();
        this.$emit("closed");
      }
    },
    resetData: function resetData() {
      this.gettingEntity = {
        isPending: false,
        cancellationToken: null,
        result: null
      };
    },
    isAdminNotConsultant: isAdminNotConsultant
  }
};